import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=832dc1cc&scoped=true"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=832dc1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832dc1cc",
  null
  
)

export default component.exports